export default __webpack_public_path__ + "static/media/isleofironstatues.2fcbbbb2.jpg";